<template lang="html">
  <div id="firebaseui-auth-container"></div>
</template>

<script>
import firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

export default {
  name: "Login",
  data() {
    return {};
  },

  mounted() {
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    firebase.auth().tenantId = "pharmacy-i4t6d";
    var uiConfig = {
      signInSuccessUrl: "/", // This redirect can be achived by route using callback.
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false
        }
      ]
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style lang="css"></style>
